import React from 'react';
import Loader from 'react-loader-spinner';

import { Container } from './styles';

const Loading: React.FC = () => {
  return (
    <Container>
      <Loader width={48} color="#0065b3" type="ThreeDots" />
    </Container>
  );
};

export default Loading;
